import styled, { css } from 'styled-components';
import palette from '@mlc/mlc-palette';
import { Color, ScreenSize } from '../../../../../enums';
import TrackableAnchor from '../../../../common/Anchor/TrackableAnchor';

export const LiBorder = styled.li`
	align-items: center;
	border: ${Color.border};
	border-style: solid;
	border-width: 0 0 1px;
	display: flex;
	flex: 1;
	list-style: none;
	margin: 0;

	&:first-child {
		border-top-width: 1px;

		a {
			padding: 10px 0;
		}
	}

	@media (max-width: ${ScreenSize.small}) {
		flex: none;
	}
`;

export const ExternalLinkIcon = styled.span`
	align-self: center;
	color: ${props => props.color || 'inherit'};
	display: inline;
	flex-grow: 1;
	min-width: 25px;
	padding-right: 0.5rem;
	text-align: right;
`;

interface AnchorProps {
	disabled?: boolean;
}

const enabledStyle = css`
	&:focus,
	&:hover {
		color: ${palette.mlcDeepAqua};
		text-decoration: underline;
	}
`;

const disabledStyle = css`
	color: ${palette.mlcWallaby};
	cursor: default;
	pointer-events: none !important;
`;

export const ListAnchor = styled(TrackableAnchor)`
	color: ${props => props.color || palette.mlcTextLink};
	display: flex;
	flex: 1;
	padding: 15px 0;
	text-decoration: none;

	${(p: AnchorProps) => (p.disabled ? disabledStyle : enabledStyle)}
`;
